import React from 'react';
import styled from 'styled-components';
import FixedRatioImage from '../../Components/FixedRatioImage';
import {Button} from 'antd';
import {navigate} from 'gatsby';
import * as AppActions from '../../AppActions';
import LandingSectionHeader from '../../Components/LandingSectionHeader';

function SpecialItem(props) {
  const {product, extraStyle} = props;
  return (
    <Card
      style={extraStyle}
      ariaLabel={product.name}
      onClick={async () => {
        await navigate(`/product?id=${product.id}`);
      }}>
      <FixedRatioImage
        width="100%"
        image={product.images[0]}
        ratio={171 / 251}
        mode="cover"
        extraCss={{marginBottom: 10}}
      />
      <div className="name">{product.name}</div>
      <div style={{flex: 1}} />
      <div className="footer">
        <div className="price">NT. {product.price}</div>
        <div style={{flex: 1}} />
      </div>
    </Card>
  );
}

function ProductsSpecials(props) {
  const {specials = []} = props;

  return (
    <Wrapper>
      <LandingSectionHeader
        title="精選商品"
        subtitle="Product Featured"
        color="#0eb407"
      />
      <SpecialItemCollection>
        {specials.map((s, i) => (
          <SpecialItem key={i} product={s} extraStyle={{marginRight: 25}} />
        ))}
        {new Array(4).fill(0).map((_f, i) => (
          <div className="filler" key={i} />
        ))}
      </SpecialItemCollection>
      <Button
        onClick={() => {
          AppActions.navigate('/products');
        }}
        style={{alignSelf: 'flex-end'}}>
        More
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 95px 45px;
  background-color: #f0f0f0;
`;

const SpecialItemCollection = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;

  @media screen and (max-width: 700px) {
    justify-content: center;
  }
  & > .filler {
    width: 300px;
    height: 1px;
    background-color: transparent;
  }
  @media screen and (max-width: 1023px) {
    & > .filler {
      width: 300px;
    }
  }
  @media screen and (max-width: 575px) {
    & > .filler {
      width: 300px;
    }
  }
`;

const Card = styled.div`
  width: 300px;
  border-radius: 20px;
  background-color: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  transition: all 400ms ease;
  cursor: pointer;
  :hover {
    box-shadow: 0 0 10px #aaa;
    transform: scale(1.05);
  }
  & .fixed-ratio-image {
    border-radius: 10px;
  }
  & > .name {
    font-family: MavenPro, sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.8;
    text-align: left;
    color: #7e7e7e;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  & > .footer {
    display: flex;
    flex-direction: row;
    & > .price {
      font-family: MavenPro, sans-serif;
      font-size: 18px;
      font-weight: bold;
      line-height: 1.5;
      text-align: left;
      color: #ffa700;
    }
    & > .actions {
      display: flex;
      width: 80px;
      justify-content: space-evenly;
    }
  }

  @media screen and (max-width: 1023px) {
    width: 300px;
  }

  @media screen and (max-width: 575px) {
    width: 300px;
  }
`;

export default ProductsSpecials;
